import DataTable, { TableColumn } from "react-data-table-component";
import userImg from "../../assets/images/user.svg";
import { Dialog } from "../../components/CommonComponents/Dialog/Dialog";
import { Log } from "../../hooks/applications.hooks";
import { TReviewWithReviewer } from "../../hooks/level-2-application-approval.hooks";
import { formatDate, formatDateAndTime } from "../../utils/date";
import { useMemo } from "react";
import { tableCustomStyles } from "../../components/CommonComponents/Table/Table";

export function RenderAllLogs({
  logs,
  onClose,
  title = "Audit History",
}: {
  title?: string;
  logs: Log[];
  onClose: () => unknown;
}) {
  const columns = useMemo(
    (): TableColumn<Log>[] => [
      {
        name: "Sr No.",
        selector: (_, i) => String((i || 0) + 1),
        center: true,
      },
      {
        name: "Field Name",
        cell: (d) => <span className="text-center">{d.fieldName || "-"}</span>,
        center: true,
      },
      {
        name: "Old Value",
        center: true,
        cell: (d) => <span className="text-center">{d.oldValue || "-"}</span>,
      },
      {
        name: "New Value",
        center: true,
        cell: (d) => <span className="text-center">{d.newValue || "-"}</span>,
      },
      {
        name: "Updated At",
        center: true,
        cell: (d) => (
          <span className="text-center">{formatDateAndTime(d.timestamp)}</span>
        ),
      },
      {
        name: "Last Updated At",
        center: true,
        cell: (d) => (
          <span className="text-center">
            {d.lastUpdateTimestamp
              ? formatDateAndTime(d.lastUpdateTimestamp)
              : "--"}
          </span>
        ),
      },
      {
        name: "Updated By",
        center: true,
        cell: (d) => <span className="text-center">{d.updatedBy ?? "--"}</span>,
      },
      {
        name: "Last Updated By",
        center: true,
        cell: (d) => (
          <span className="text-center">{d.lastUpdatedBy ?? "--"}</span>
        ),
      },
    ],
    []
  );

  return (
    <div className="w-full grow overflow-auto pr-4">
      <DataTable
        keyField="id"
        className="mt-4"
        columns={columns}
        data={logs}
        customStyles={tableCustomStyles}
      />
    </div>
  );
}
